module.exports = __webpack_public_path__ + "img/qanAbg.d0473a6d.png";